const clientId = process.env.REACT_APP_AZURE_CLIENT_ID || "";
const tenantId = process.env.REACT_APP_AZURE_TENANT_ID || "";
const redirectUri:any = process.env.REACT_APP_AZURE_REDIRECT_URI;
const scope = process.env.REACT_APP_AZURE_SCOPE || "openid profile email";

const loginWithAzure = () => {
  const authUrl =
    `https://login.microsoftonline.com/${tenantId}/oauth2/v2.0/authorize?` +
    `client_id=${clientId}&response_type=code&redirect_uri=${encodeURIComponent(
      redirectUri
    )}` +
    `&scope=${encodeURIComponent(scope)}`;

  window.location.href = authUrl;
};

export default loginWithAzure;
